import Vue from 'vue';
Vue.prototype.$nav = (url: string) => (window.location.href = url);
